/*
 * currentEntityId reducer
 */
import { SET_CURRENT_ENTITY_ID } from './constants';
import { SET_CURRENT_ORGANIZATION_ID } from '../currentOrganizationId/constants';
import { SET_CURRENT_SEASON_ID } from '../currentSeasonId/constants';

type State = number;

type Action = {
    +type: string,
    +payload: Object
};

const initialState = 0;

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case SET_CURRENT_ENTITY_ID:
            return action.payload.entityId;
        case SET_CURRENT_ORGANIZATION_ID:
            return initialState;
        case SET_CURRENT_SEASON_ID:
            return initialState;
        default:
            return state;
    }
}
